import { CheckBadgeIcon } from "@heroicons/react/24/solid";
import Image from "next/image";

interface UsernameProps {
  profilePictureUrl?: string;
  username: string;
  verifiedAccount: boolean;
}

export function Username(props: UsernameProps) {
  return (
    <div className="flex items-center justify-between gap-2">
      <div className="avatar placeholder">
        {props.profilePictureUrl ? (
          <img
            src={props.profilePictureUrl}
            alt={"Magic Hour Profile Picture"}
            width={32}
            height={32}
            className="h-8! w-8! rounded-full"
          />
        ) : (
          <div className="bg-primary text-neutral-content w-8 rounded-full">
            <span>{(props.username[0] || "-").toUpperCase()}</span>
          </div>
        )}
      </div>
      <span className="text-lg font-bold">by {props.username}</span>

      {props.verifiedAccount && <CheckBadgeIcon className="h-4 w-4 text-blue-400" />}
    </div>
  );
}
